import { Vue, Component, Watch } from 'vue-property-decorator'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppTextField from '@/components/AppTextField.vue'
import AppFormItem from '@/components/AppFormItem.vue'
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue'
import { findDealer } from '../DealerList/gql'
import { updateDealer, resetDealerPassword } from './gql'
import { AreaModel } from '@/interfaces/area'
import AppDialog from '@/components/AppDialog.vue'
import { TypedGqlError } from '@/interfaces/error'

Component.registerHooks([
  'beforeRouteLeave'
])

@Component({
  components: {
    AppBreadcrumbs,
    AppFormItem,
    AppSimpleDistrictSelector,
    AppTextField,
    AppDialog
  }
})
export default class EditDealer extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: '经销商管理'
    },
    {
      text: '经销商',
      to: { name: 'DealerList' }
    }
  ]

  dealerInput: any = { realname: '', phone: '', openId: '', email: '', storeName: '', storePhone: '', sharingProportion: '0' }
  originInput = ''
  dealerId = ''
  applyArea: AreaModel | null = null

  disabledActions = true

  // 登录人角色
  role = sessionStorage.getItem('role')

  resetPwdDialog = {
    show: false,
    title: '重置经销商密码',
    text: '该操作会重置该经销商密码，新密码为该经销商登录账号'
  }

  @Watch('dealerInput', { deep: true })
  dealerInputChange (val: any) {
    if (JSON.stringify(val) !== this.originInput) {
      this.disabledActions = false
    } else {
      this.disabledActions = true
    }
  }

  // mounted
  async mounted () {
    const { id } = this.$route.params
    this.dealerId = id
    await this.getDealer()
  }

  async getDealer () {
    try {
      const result = await this.$apollo.query({
        query: findDealer,
        variables: {
          dealerId: +this.dealerId
        }
      })
      if (result) {
        const { realname, user, areas, openId, storeName, storePhone, sharingProportion } = result.data.findDealer
        this.breadcrumbs = [
          {
            text: '经销商管理'
          },
          {
            text: '经销商',
            to: { name: 'DealerList' }
          }
        ]
        this.breadcrumbs.push({ text: `${realname}` })
        this.dealerInput = {
          openId: openId || '',
          realname: realname || '',
          storeName: storeName || '',
          storePhone: storePhone || '',
          email: user.email || '',
          phone: user.phone || '',
          sharingProportion: (sharingProportion || 0) + ''
        }
        this.originInput = JSON.stringify(this.dealerInput)
        // this.disabledActions = true
        this.applyArea = areas[0] as AreaModel
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 确认修改
  async submitForm () {
    const { realname, email, storeName, storePhone, phone, sharingProportion } = this.dealerInput
    const input: any = {
      realname,
      email,
      storeName,
      storePhone,
      phone
    }
    if (this.role === 'ADMIN' || this.role === 'ROOT') {
      input.sharingProportion = +sharingProportion
    }
    try {
      const result = await this.$apollo.query({
        query: updateDealer,
        variables: {
          dealerId: +this.dealerId,
          input
        }
      })
      if (result) {
        showNotification({
          msg: '修改成功！',
          type: SnackType.Info
        })
        this.disabledActions = true
        this.$router.go(-1)
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async beforeRouteLeave (to: any, from: any, next: any) {
    if (!this.disabledActions) {
      const res = confirm('页面修改尚未保存，是否确定要离开？')
      next(res)
    } else {
      next()
    }
  }

  resetPassword () {
    this.resetPwdDialog.show = true
  }

  async resetPasswordConfirm () {
    this.resetPwdDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: resetDealerPassword,
        variables: {
          dealerId: +this.dealerId
        }
      })
      if (result) {
        showNotification({
          msg: '重置成功！',
          type: SnackType.Info
        })
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }
}
